<template>
  <div class="uar_tab">
    <ul class="clear">
      <li>
        <router-link :to="{ name:'charge.index'}" :class="{'current': position=='index'}">充值记录</router-link>
      </li>
      <li>
        <router-link :to="{ name:'charge.card'}" :class="{'current': position=='card'}">充值卡</router-link>
      </li>
      <li v-if="chargeStatusValue === 1">
        <router-link :to="{ name:'charge.integral'}" :class="{'current': position=='integral'}">积分充值</router-link>
      </li>
      <li v-if="chargeStatusValue === 1">
        <router-link :to="{ name:'charge.vip'}" :class="{'current': position=='vip'}">会员充值</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
// 加载组件
// import axios from "axios";
// 加载api
import { getSysConfig } from "../api/index";
export default {
  props: {
    position: String
  },
  data() {
    return {
      chargeStatusValue: 1
    };
  },
  mounted() {
    getSysConfig({ flag: "charge_status" }).then(res => {
      this.chargeStatusValue = parseInt(res.data.value);
    });
  }
};
</script>

<style scoped>
</style>